module.exports = __webpack_public_path__ + "static/media/12596306_1061103970577691_233334087_n.c7f084da.jpg";